import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import FormGroup from "@material-ui/core/FormGroup";
import Tooltip from "@material-ui/core/Tooltip";
import FormControl from "@material-ui/core/FormControl";
import NativeSelect from "@material-ui/core/NativeSelect";
import Input from "@material-ui/core/Input";
import TextField from "@material-ui/core/TextField";
import ConfirmDialog from "../components/ConfirmDialog";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";

import {
  getSorting,
  getNumberSorting,
  getFloatSorting,
} from "../components/Utils";
import { getErrorString } from "../display/ErrorStrings";
import CustomTableHead from "../components/CustomTableHead";
import PopupMessage from "../components/PopupMessage";
import SuspectItemDetails from "../details/SuspectItemDetails";

import DeselectIcon from "@material-ui/icons/BackspaceOutlined";
import PayIcon from "@material-ui/icons/CheckOutlined";
import ReturnIcon from "@material-ui/icons/CloseOutlined";
import CircularProgress from "@material-ui/core/CircularProgress";

import CustomPaginatorActions from "../components/CustomPaginatorActions";
import TablePagination from "@material-ui/core/TablePagination";

import { ROWS_PER_PAGE_OPTIONS } from "../components/Constants";

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },

  boldCell: {
    fontWeight: "bold",
    fontSize: 14,
  },

  vCenterItems: {
    display: "flex",
    alignItems: "center",
  },
  progress: {
    margin: theme.spacing.unit,
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "secondary",
      cursor: "pointer",
    },
  },
});

const columnData = [
  {
    id: "date",
    numeric: false,
    disablePadding: false,
    label: "Date",
  },
  {
    id: "trace",
    numeric: false,
    disablePadding: false,
    label: "Trace",
  },
  {
    id: "checkNumber",
    numeric: false,
    disablePadding: false,
    label: "Check No.",
  },
  {
    id: "amount",
    numeric: true,
    disablePadding: false,
    label: "Amount($)",
  },
  {
    id: "payee",
    numeric: false,
    disablePadding: false,
    label: "Payee",
  },
  {
    id: "statusDescr",
    numeric: false,
    disablePadding: false,
    label: "Status",
  },
  {
    id: "reasonRejected",
    numeric: false,
    disablePadding: false,
    label: "Reason Rejected",
  },
];

class CheckExceptionHomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      notifyString: "",
      returnCodes: [],
      items: [],
      selectedItemId: 0,
      selectedItemObject: {},
      order: "asc",
      orderBy: "0",
      returnCode: "000",
      payDisposition: true,
      confirmDisposition: false,
      viewPopup: false,
      searchInProgress: false,
      totalCount: 0,
      page: 0,
      rowsPerPage: window.sco_large_items_per_page,
    };
    this.onClosePopup = this.onClosePopup.bind(this);
    this.onDisposition = this.onDisposition.bind(this);
    this.handleBulkDisposition = this.handleBulkDisposition.bind(this);
  }

  componentDidMount() {
    this.search(0, this.state.rowsPerPage);
  }

  handleChangeRowsPerPage(e) {
    this.setState({ rowsPerPage: e.target.value });
    this.setState({ page: 0 });
    window.sco_large_items_per_page = e.target.value;
    this.search(0, e.target.value);
  }

  handleChangePage = (event, page) => {
    this.setState({ page: page });
    this.search(page, this.state.rowsPerPage);
  };

  search(page, rowsPerPage) {
    this.setState({ searchInProgress: true });
    var account = this.props.account;
    account.secureToken = this.props.secureToken;
    account.page = page;
    account.num_items = rowsPerPage;
    fetch("on_check_exception_home_page_search", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(this.props.account),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
          this.setState({ viewPopup: true });
        } else {
          let newData = reply.items;
          this.setState({ items: newData });
          this.setState({ totalCount: reply.totalCount });
          this.setState({ returnCodes: reply.returnCodes });
          if (reply.totalCount === 0) {
            this.setState({
              notifyString: getErrorString(
                "general.info.search.empty",
                "Total number of items is 0."
              ),
            });
            this.setState({ viewPopup: true });
          }
        }
        this.setState({ searchInProgress: false });
      })
      .catch((error) => {
        this.setState({ searchInProgress: false });
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ totalCount: 0 });
        this.setState({ viewPopup: true });
      });
  }

  handleBulkNotes(e) {
    this.setState({ notes: e.target.value });
  }

  validateBulkData() {
    // no pending items allowed for bulk decisions
    for (let i = 0; i < this.state.items.length; i++) {
      let status = this.state.items[i].status;
      if (status === "P1" || status === "P2") {
        this.setState({
          errorString: getErrorString(
            "decision.bulk.error",
            "Bulk decisions are not allowed on pending items. Please decision any pending items."
          ),
        });
        this.setState({ viewPopup: true });
        return false;
      }
    }
    return true;
  }

  handleBulkPay(e) {
    if (this.props.viewOnly) {
      this.setState({
        errorString: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    if (!this.validateBulkData()) {
      return;
    }
    this.setState({ payDisposition: true });
    this.setState({ confirmDisposition: true });
  }

  handleBulkReturn(e) {
    if (this.props.viewOnly) {
      this.setState({
        errorString: getErrorString(
          "viewOnly.warning",
          "Operation not allowed in support mode."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    if (!this.validateBulkData()) {
      return;
    }
    if (this.state.returnCode === "000" || this.state.returnCode.length === 0) {
      this.setState({
        errorString: getErrorString(
          "disposition.reason.error",
          "Return Reason is required."
        ),
      });
      this.setState({ viewPopup: true });
      return;
    }
    this.setState({ payDisposition: false });
    this.setState({ confirmDisposition: true });
  }

  handleBulkReturnCode(e) {
    this.setState({ returnCode: e.target.value });
  }
  handleBulkDisposition(e, action) {
    this.setState({ confirmDisposition: false });
    // confirmed
    if (action === 1) {
      fetch("on_bulk_disposition_request", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          transit: this.props.account.transit,
          account: this.props.account.account,
          pay: this.state.payDisposition,
          comment: this.state.notes,
          items: this.state.items,
          returnCode: this.state.returnCode,
          secureToken: this.props.secureToken,
        }),
      })
        .then(function (res) {
          if (!res.ok) {
            throw Error(res.status + " (" + res.statusText + ")");
          }
          return res;
        })
        .then((res) => res.text())
        .then((text) => {
          var reply = JSON.parse(text);
          if (!reply.authenticated) {
            this.props.history.push("/expired");
          } else if (reply.error) {
            this.setState({ errorString: reply.errorString });
            this.setState({ viewPopup: true });
          } else {
            this.props.onClose(null);
          }
        })
        .catch((error) => {
          this.setState({
            errorString:
              getErrorString(
                "general.server.status.error",
                "The server responded with a status of "
              ) + error.message,
          });
          this.setState({ viewPopup: true });
        });
    }
  }

  handleRequestSort = (event, property) => {
    if (property.indexOf("nosort") !== -1) {
      return;
    }
    const orderBy = property;
    let order = "desc";
    if (this.state.orderBy === property) {
      if (this.state.order === "desc") {
        order = "asc";
      }
    } else {
      order = this.state.order;
    }
    this.setState({ order, orderBy });
    this.sort(orderBy, order, this.state.items);
  };

  sort(orderBy, order, data) {
    if (orderBy.length > 0 && order.length > 0) {
      if (orderBy === "checkNumber" || orderBy === "trace") {
        data.sort(getNumberSorting(order, orderBy));
      } else if (orderBy === "amount") {
        data.sort(getFloatSorting(order, "rowAmount"));
      } else {
        data.sort(getSorting(order, orderBy));
      }
      this.setState({ items: data });
    }
  }

  handleSelectItem(event, itemKey) {
    this.setState({
      selectedItemObject: this.state.items[this.getItemIndex(itemKey)],
    });
    this.setState({ selectedItemId: itemKey });
  }

  onClosePopup(e) {
    this.setState({ viewPopup: false });
    this.setState({ errorString: "" });
    this.setState({ notifyString: "" });
    this.setState({ selectedItemId: 0 });
  }

  onDisposition(e) {
    let items = this.state.items;
    if (items.length === 1) {
      this.props.onClose(null);
    } else {
      items.splice(this.getItemIndex(this.state.selectedItemId), 1);
      this.setState({ items: items });
      this.setState({ selectedItemId: 0 });
    }
  }

  getItemIndex(objectIndex) {
    let items = this.state.items;
    let i;
    for (i = 0; i < items.length; i++) {
      if (items[i].index === objectIndex) {
        return i;
      }
    }
    return objectIndex;
  }

  handleUnselectAccount(e) {
    this.props.onClose();
  }

  render() {
    const { classes } = this.props;
    const { order, orderBy } = this.state;
    let data = this.state.items;
    let { t } = this.props;
    const { rowsPerPage, page, totalCount } = this.state;
    return (
      <div>
        {this.state.confirmDisposition && (
          <ConfirmDialog
            title={
              this.state.payDisposition
                ? t("confirmBulkPay.label")
                : t("confirmBulkReturn.label")
            }
            text={
              this.state.payDisposition
                ? t("payBulkQuestion.label")
                : t("returnBulkQuestion.label")
            }
            onCloseConfirm={this.handleBulkDisposition}
          />
        )}
        {this.state.viewPopup && this.state.errorString.length > 0 && (
          <PopupMessage
            title="Error"
            text={this.state.errorString}
            error={true}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.viewPopup && this.state.notifyString.length > 0 && (
          <PopupMessage
            title={getErrorString("general.info.title", "Information")}
            text={this.state.notifyString}
            error={false}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.selectedItemId !== 0 && (
          <div style={{ marginTop: 20 }}>
            <Typography variant="body1" color="primary">
              &nbsp;&nbsp;{t("selectedTransit.label")} &nbsp;
              <span>
                <strong>{this.props.account.transit}</strong>
              </span>
              &nbsp;&nbsp;{t("account.label")}&nbsp;
              <span>
                <strong>{this.props.account.account}</strong>
              </span>
            </Typography>

            <SuspectItemDetails
              scrub={false}
              uiExclusionsList={this.props.uiExclusionsList}
              viewOnly={this.props.viewOnly}
              secureToken={this.props.secureToken}
              item={this.state.selectedItemObject}
              history={this.props.history}
              accountObject={this.props.account}
              onClosePopup={this.onClosePopup}
              returnCodes={this.state.returnCodes}
              onDisposition={this.onDisposition}
            />
          </div>
        )}
        {this.state.selectedItemId === 0 &&
          this.state.totalCount === 0 &&
          this.state.errorString.length === 0 &&
          this.state.searchInProgress && (
            <div>
              <br></br>
              <CircularProgress className={classes.progress} />
            </div>
          )}

        {this.state.selectedItemId === 0 &&
          this.state.totalCount > 0 &&
          !this.state.searchInProgress && (
            <div>
              <Typography variant="h6" color="primary" style={{ margin: 10 }}>
                {t("checkExceptions.label")}
              </Typography>
              <Typography color="primary" variant="body1">
                &nbsp;&nbsp;{t("notePendingMissing.label")}
              </Typography>
              <Typography variant="body1" color="primary">
                &nbsp;&nbsp;{t("selectedTransit.label")}&nbsp;
                <span>
                  <strong>{this.props.account.transit}</strong>
                </span>
                &nbsp;&nbsp;{t("account.label")}&nbsp;
                <span>
                  <strong>{this.props.account.account}</strong>
                </span>
                &nbsp;&nbsp;
                <Button
                  color="primary"
                  onClick={(event) => this.handleUnselectAccount(event)}
                >
                  <DeselectIcon />
                  &nbsp;{t("deselect.button")}
                </Button>
              </Typography>

              <Paper elevation={5}>
                <TablePagination
                  component="div"
                  count={totalCount}
                  rowsPerPage={rowsPerPage}
                  rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
                  page={page}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={(event) =>
                    this.handleChangeRowsPerPage(event)
                  }
                  ActionsComponent={CustomPaginatorActions}
                />
                <Table
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  stickyHeader
                >
                  <CustomTableHead
                    order={order}
                    orderBy={orderBy}
                    columnData={columnData}
                    onRequestSort={this.handleRequestSort}
                  />
                  <TableBody>
                    {data.map((n) => {
                      return (
                        <TableRow
                          hover
                          className={classes.tableRow}
                          onClick={(event) =>
                            this.handleSelectItem(event, n.index)
                          }
                          key={n.index}
                          title={t("viewDetail.label")}
                        >
                          <TableCell style={{ width: "10%" }}>
                            {n.date}
                          </TableCell>
                          <TableCell style={{ width: "18%", padding: 0 }}>
                            {n.trace}
                          </TableCell>
                          <TableCell style={{ width: "8%", padding: 0 }}>
                            {n.checkNumber}
                          </TableCell>
                          <TableCell
                            style={{ width: "9%", padding: 0 }}
                            numeric={true}
                          >
                            {n.amount}
                          </TableCell>
                          <TableCell
                            style={{ width: "20%", wordWrap: "break-word" }}
                          >
                            {n.payee}
                          </TableCell>
                          <TableCell style={{ width: "15%", padding: 0 }}>
                            {n.statusDescr}
                          </TableCell>
                          <TableCell style={{ width: "20%", padding: 0 }}>
                            {n.reasonRejected}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </Paper>
              <div style={{ marginTop: 30 }}>
                <Paper elevation={5}>
                  <FormGroup row>
                    <p>
                      &nbsp;&nbsp;<strong>{t("bulkDecisions.label")}</strong>
                      &nbsp;&nbsp;&nbsp;
                    </p>
                    <Tooltip title={t("payAllItem.tip")}>
                      <Button
                        color="primary"
                        onClick={(event) => this.handleBulkPay(event)}
                      >
                        <PayIcon />
                        &nbsp;{t("pay.label")}
                      </Button>
                    </Tooltip>
                    <Tooltip title={t("returnAllItem.tip")}>
                      <Button
                        color="primary"
                        onClick={(event) => this.handleBulkReturn(event)}
                      >
                        <ReturnIcon />
                        &nbsp;{t("return.label")}
                      </Button>
                    </Tooltip>
                    <Typography style={{ marginBottom: 0 }} variant="caption">
                      {t("returnReason.label")}&nbsp;&nbsp;
                    </Typography>
                    <FormControl>
                      <NativeSelect
                        style={{
                          height: 27,
                          verticalAlign: "textTop",
                          margin: 5,
                        }}
                        defaultValue={this.state.returnCode}
                        input={<Input id="return_code" />}
                        onChange={(event) => this.handleBulkReturnCode(event)}
                      >
                        {this.state.returnCodes.map((n) => {
                          return <option value={n.id}>{n.description}</option>;
                        })}
                      </NativeSelect>
                    </FormControl>
                  </FormGroup>
                  <FormGroup row>
                    &nbsp;&nbsp;
                    <div>
                      <TextField
                        margin="dense"
                        id="notes"
                        label={t("notes.label")}
                        onChange={(event) => this.handleBulkNotes(event)}
                      />
                    </div>
                  </FormGroup>
                </Paper>
              </div>
              <Divider />
            </div>
          )}
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(CheckExceptionHomePage));
